"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractRefiners_1 = require("../abstractRefiners");

var UnlikelyFormatFilter = /*#__PURE__*/function (_abstractRefiners_1$F) {
  _inherits(UnlikelyFormatFilter, _abstractRefiners_1$F);

  var _super = _createSuper(UnlikelyFormatFilter);

  function UnlikelyFormatFilter(strictMode) {
    var _this;

    _classCallCheck(this, UnlikelyFormatFilter);

    _this = _super.call(this);
    _this.strictMode = strictMode;
    return _this;
  }

  _createClass(UnlikelyFormatFilter, [{
    key: "isValid",
    value: function isValid(context, result) {
      if (result.text.replace(" ", "").match(/^\d*(\.\d*)?$/)) {
        context.debug(function () {
          console.log("Removing unlikely result '".concat(result.text, "'"));
        });
        return false;
      }

      if (!result.start.isValidDate()) {
        context.debug(function () {
          console.log("Removing invalid result: ".concat(result, " (").concat(result.start, ")"));
        });
        return false;
      }

      if (result.end && !result.end.isValidDate()) {
        context.debug(function () {
          console.log("Removing invalid result: ".concat(result, " (").concat(result.end, ")"));
        });
        return false;
      }

      if (this.strictMode) {
        return this.isStrictModeValid(context, result);
      }

      return true;
    }
  }, {
    key: "isStrictModeValid",
    value: function isStrictModeValid(context, result) {
      if (result.start.isOnlyWeekdayComponent()) {
        context.debug(function () {
          console.log("(Strict) Removing weekday only component: ".concat(result, " (").concat(result.end, ")"));
        });
        return false;
      }

      if (result.start.isOnlyTime() && (!result.start.isCertain("hour") || !result.start.isCertain("minute"))) {
        context.debug(function () {
          console.log("(Strict) Removing uncertain time component: ".concat(result, " (").concat(result.end, ")"));
        });
        return false;
      }

      return true;
    }
  }]);

  return UnlikelyFormatFilter;
}(abstractRefiners_1.Filter);

exports.default = UnlikelyFormatFilter;